module.exports = __webpack_public_path__ + "img/apply_register_04.bd9ebf03.png";